import * as React from 'react';

function SvgChina(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.726h35.537V0H0v20.726z"
        fill="#CB1D23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.417 7.503l.667-2.068-1.752-1.287 2.172-.004.678-2.063.676 2.063 2.173.009-1.756 1.282.664 2.068L5.18 6.225 3.417 7.503zM9.477 8.62l.734.297.51-.608-.054.79.733.298-.767.194-.057.782-.42-.666-.767.186.506-.603-.418-.67zM13.45 4.645l-.78-.137-.374.699-.109-.781-.781-.145.71-.343-.107-.786.55.566.711-.343-.371.7.55.57zM11.796 8.185l.241-.753-.638-.467h.792l.244-.752.246.752h.792l-.638.467.24.753-.64-.462-.639.462zM9.517 1.315l.717.335.54-.578-.093.785.713.34-.774.149-.098.785-.386-.691-.775.145.537-.58-.381-.69z"
        fill="#F7DE29"
      />
    </svg>
  );
}

export default SvgChina;
